import React from 'react';

import Skeleton from '~/components/core/Atomic/Skeleton';

/** One log entry's placeholder: the dot it hangs from and its card. */
const LogEntrySkeleton: React.FC = () => (
  <div className="flex gap-12">
    <Skeleton variant="rectangular" width={12} height={12} className="mt-8 shrink-0 rounded-full" />
    <Skeleton variant="rectangular" height={112} className="flex-1 rounded-lg" />
  </div>
);

export default LogEntrySkeleton;
